import React, {
  Suspense,
  useEffect,
} from 'react'

import PropTypes from 'prop-types'

import Termly from 'termly-namespace'

import UINames from 'constants/ui-names'

import { useDisplayManager } from 'components/DisplayManager'

import shouldRenderReminder from 'utils/startProcess/onAllApiRespond/shouldRenderReminder'

// I'm not bothering with lazy-loading this because this is a small
// component and its the default render for the returning visitor
// case. So, I guess you could say that we're optimizing for the
// users who've already paid their "compliance tax."
import FloatingPreferencesButton from './FloatingPreferencesButton'

// The lazy wrappers make testing possible
import LazyConsentPrompt from './LazyConsentPrompt'
import LazyCookieDetails from './LazyCookieDetails'
import LazyGACMDetails from './LazyGACMDetails'
import LazyDocumentModal from './LazyDocumentModal'
import LazyPreferenceModal from './LazyPreferenceModal'
import LazyTCFDetails from './LazyTCFDetails'

const DISPLAY_MAP = {
  [UINames.COOKIE_DETAILS]: LazyCookieDetails,
  [UINames.DOC_MODAL]: LazyDocumentModal,
  [UINames.GACM_DETAILS]: LazyGACMDetails,
  [UINames.PREFERENCES]: LazyPreferenceModal,
  [UINames.PROMPT]: LazyConsentPrompt,
  [UINames.TCF_DETAILS]: LazyTCFDetails,
}


export default function ResourceBlocker({ cookiePolicy }) {
  const { activeUI, pushActiveUI } = useDisplayManager()

  useEffect(() => {
    if ( shouldRenderReminder({ cookiePolicy }) ) {
      Termly.tcf?.expireConsents()

      pushActiveUI(UINames.PROMPT)
    }
  }, [cookiePolicy, pushActiveUI])

  const Component = DISPLAY_MAP[activeUI.name]

  if ( !Component ) {
    return (
      <FloatingPreferencesButton />
    )
  }

  return (
    <Suspense fallback={ null }>
      <Component
        { ...activeUI.props }
      />
    </Suspense>
  )
}

ResourceBlocker.propTypes = {
  cookiePolicy: PropTypes.shape({
    name: PropTypes.string,
    published_document_version_id: PropTypes.number,
  }),
}
